import { render, staticRenderFns } from "./common-problem.vue?vue&type=template&id=16a66367&scoped=true"
import script from "./common-problem.vue?vue&type=script&lang=js"
export * from "./common-problem.vue?vue&type=script&lang=js"
import style0 from "./common-problem.vue?vue&type=style&index=0&id=16a66367&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a66367",
  null
  
)

export default component.exports